/**
 * File d’attente sync visite Pass (échecs techniques) — helpers purs.
 */

import {
  normalizePassVisitFailureReason,
  type PassVisitFailureReason,
  type PassVisitResultLike,
} from './visitFeedback';

export type LoyaltyPassVisitOutboxStatus =
  | 'pending'
  | 'retrying'
  | 'synced'
  | 'failed_permanent'
  | 'dismissed';

/** Raisons pour lesquelles on enqueue + modale support (pas toast métier seul). */
const TECHNICAL_FAILURE_REASONS = new Set<PassVisitFailureReason>([
  'TIMEOUT',
  'BRIDGE_FAILED',
  'bridge_not_configured',
  'UNKNOWN',
]);

export function isTechnicalPassVisitFailure(
  reason: string | null | undefined
): boolean {
  const normalized = normalizePassVisitFailureReason(reason);
  return TECHNICAL_FAILURE_REASONS.has(normalized);
}

/** Modale caisse « J’ai compris » (file SA) vs toast warning métier. */
export function shouldShowPassVisitOutboxModal(
  visit?: PassVisitResultLike | null,
  err?: unknown
): boolean {
  if (visit?.outboxQueued === true) return true;
  if (err) {
    const msg =
      err && typeof err === 'object' && 'message' in err
        ? String((err as { message?: string }).message || '')
        : '';
    return isTechnicalPassVisitFailure(normalizePassVisitFailureReason(msg));
  }
  if (visit && visit.synced === false) {
    return isTechnicalPassVisitFailure(visit.reason);
  }
  return false;
}

export type LoyaltyPassVisitOutboxLine = {
  lineId: string;
  kind: 'service' | 'product';
  categoryId?: string;
  amountXaf: number;
  qty: number;
};

export type LoyaltyPassVisitOutboxDoc = {
  id: string;
  businessId: string;
  transactionGroupId: string;
  clientId?: string;
  passId?: string;
  ticketAmountXaf: number;
  lines?: LoyaltyPassVisitOutboxLine[];
  status: LoyaltyPassVisitOutboxStatus;
  lastErrorReason?: string;
  lastErrorAt?: Date | null;
  attemptCount: number;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  createdByUid?: string;
  lastRetriedByUid?: string;
  clientName?: string;
  clientPhone?: string;
};
